import React from 'react'

import ItemCardListExperimental from './listDefault.v1'
import ItemCardGridDefault from './gridDefault'

const ItemCard = ({
  viewType,
  videoMuted,
  itemProps,
  currentSite,
  muteVideo,
  imageType
}) => {
  if (viewType === 'grid') {
    return <ItemCardGridDefault {...itemProps} />
  }

  return (
    <ItemCardListExperimental
      {...itemProps}
      muted={videoMuted}
      muteVideo={muteVideo}
      imageType={imageType}
    />
  )
}

export default ItemCard



// WEBPACK FOOTER //
// ./client/components/itemCard/ItemCardExperimental.js